module.exports = __webpack_public_path__ + "static/home-campus@large-d5e2035f11bcaf606f24ac9fc6f9b8b2.jpg";